import { createContext } from 'react';
import AppContextPropsType from './AppContextPropsType';

export default createContext<AppContextPropsType>(undefined);
